import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create taskType API
const taskTypeAPI = createApi({
  reducerPath:"taskTypeAPI",
  baseQuery:customFetchBase,
  endpoints:(builder)=>({
    // taskType management Endpoints

    // Add taskType 
    addTaskType: builder.mutation({
      query: (data) => ({
          url: `/TaskType/AddTaskType`,
          method: 'POST',
          body: transformRequest(data), 
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    // Query to get all taskType
    getAllTaskTypeList: builder.query({
      query: () => ({
          url: `/TaskType/GetAllTaskTypeList`,
          method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    // Query to get taskType by Id
    getTaskTypeById: builder.query({
      query: (TaskTypeId) => ({
        url: `/TaskType/GetTaskTypeByID?TaskTypeId=${Number(TaskTypeId)}`,
        method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse : transformErrorResponse,
    }),

    // Update taskType
    updateTaskType: builder.mutation({
      query:(data) => ({
        url: `/TaskType/UpdateTaskTypeByID`,
        method: 'POST',
        body:transformRequest(data),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    // Delete taskType
    deleteTaskType: builder.mutation({
      query: (data) => ({
          url: `TaskType/DeleteTaskType?id=${data}`,
          method: 'POST',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
  }),
})

// Extract hooks for easy access to various API requests 
export const {
  useAddTaskTypeMutation,
  useLazyGetAllTaskTypeListQuery,
  useLazyGetTaskTypeByIdQuery,
  useupdateTaskTypeMutation,
  useDeleteTaskTypeMutation,
} =taskTypeAPI;

export default taskTypeAPI;